<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>العمليات خلال الشهر</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div v-show="$per.value.saveRegions" class='panel-heading'>
                              هنا يتم عرض جميع عمليات الموظف الحالى خلال الشهر
                              </div>
                              <div class='form-group col-lg-6 col-sm-6'>
                                <h4 >الشهر:</h4>
                                <select class="form-control" style="padding: 1px" v-model="thisMonth">
                                  <option v-for="item in monthList" v-bind:key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-6 col-sm-6'>
                                <h4 >&nbsp;</h4>
                                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                  <b>عرض</b>
                                </button>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>
                                        <th style='text-align: center'>م</th>
                                        <th style='text-align: center'>الكود</th>
                                          <th style='text-align: center'>الاسم</th>
                                          <th style='text-align: center'>العملية</th>
                                          <th style='text-align: center'>التاريخ</th>
                                          <th style='text-align: center'>النوع</th>
                                          <th style='text-align: center'>المقدم</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='(record, index) in records' :key='record.id'>
                                          <td align='center'>{{index + 1}}</td>
                                          <td align='center'>{{record.rec_id}}</td>
                                          <td align='center'>{{record.name}}</td>
                                          <td align='center'>{{record.offer_name}}</td>
                                          <td align='center'>{{record.date}}</td>
                                          <td align='center'>{{record.type}}</td>
                                          <td align='center'>{{record.paid}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'EmpPayrollDetails',
  data () {
    return {
      monthList: [{id: 0, name: 'الشهر الحالى'}, {id: 1, name: 'الشهر السابق'}],
      thisMonth: 0,
      validationErrors: '',
      records: {},
      type: '',
      successShow: false,
      isLoadingData: false
    }
  },
  methods: {
    GetData () {
      var dateObj = new Date()
      var m = dateObj.getUTCMonth() + 1
      var mm = dateObj.getUTCMonth()
      var y = dateObj.getUTCFullYear()
      var month = ''
      if (this.thisMonth === 0) {
        month = (y + '-' + m + '-01')
      } else {
        if (mm === 0) {
          m = 12
          y = y - 1
        } else {
          m = m - 1
        }
        month = (y + '-' + m + '-01')
      }
      this.type = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-emp-payroll-details', {
        token: localStorage.getItem('token'),
        date: month
      })
        .then(({ data }) => {
          this.records = data.rec
          this.type = data.type
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/EmpPayrollDetails.vue